<div fxLayout="row" fxLayoutAlign="space-between" class="ocl-control-container">
    <div class="dx-field">
        <div class="dx-field-label">
            Client <span class="ocl-required-indicator" *ngIf="required">*</span>
        </div>
        <div class="dx-field-value">
            <dx-drop-down-box
                id="clientDropDown"
                valueExpr="id"
                placeholder="Select a client..."
                [showClearButton]="clearBtn"
                [deferRendering]="false"
                [dataSource]="dataSource.value"
                displayExpr="name"
                [value]="selectedRowKeys"
                (onValueChanged)="valueChanged($event)">
                <div *dxTemplate="let data of 'content'" id="clientPickerContainer">
                    <dx-data-grid
                        #grid
                        [dataSource]="dataSource.value"
                        [hoverStateEnabled]="true"
                        [showRowLines]="true"
                        [showBorders]="true"
                        [highlightChanges]="true"
                        [filterRow]="{ visible: true }"
                        [scrolling]="{ mode: 'infinite' }"
                        [(selectedRowKeys)]="selectedRowKeys"
                        [allowColumnResizing]="true"
                        [height]="'100%'"
                        [wordWrapEnabled]="true"
                        (onEditorPrepared)="cellPrepared($event)"
                        (onCellPrepared)="onCellPrepared($event)"
                        [columnHidingEnabled]="isPhoneOrTablet">
                            <dxo-filter-panel [visible]="!isPhoneOrTablet"></dxo-filter-panel>
                            <dxo-remote-operations [paging]="true" [filtering]="true" [sorting]="true" ></dxo-remote-operations>
                            <dxi-column dataField="code" caption="Code" width="50"></dxi-column>
                            <dxi-column dataField="name" caption="Name"></dxi-column>
                        <dxo-selection [mode]="selection" [allowSelectAll]="selectAll" [deferred]="false"></dxo-selection>
                    </dx-data-grid>
                </div>
                <dx-validator *ngIf="required" [validationGroup]="validationGroup">
                    <dxi-validation-rule type="required" message="Client is required"></dxi-validation-rule>
                </dx-validator>
            </dx-drop-down-box>
        </div>
    </div>
</div>
<dx-tooltip #gridTooltip>
  <div *dxTemplate="let data = data of 'content'">
    Clear Selection
  </div>
</dx-tooltip>
